const config = [{
    "platform": "base",
    "apiName": "/prd9",
    "loginTitle": "大气网格化智能监测平台",
    "differentApi":{
        "sensorType": "importantSensors",
        "latestSamplesType": "latestRealtimeSamples"
    },
    "appkey": "08e51285",
    "secret": "9f108d10d3f040068beec03af3375078",
    "opUserUuid": "0be83d40695011e7981e0f190ed6d2e7",
    "netZoneUuid": "94f5eb89b51c4792a17a90b2a367bc5b",
    "appkey150": "06b88c1d",
    "secret150": "8db4965cd97943a5ba763acd0a95fc02",
    "opUserUuid150": "0be83d40695011e7981e0f190ed6d2e7",
    "netZoneUuid150": "fcd5fe6515734c099ffac787e39c225b",

},
{
    "platform": "shenyang",
    "apiName": "/shenyang",
    "loginTitle": "沈阳市扬尘污染管控平台",
    "differentApi":{
        "sensorType": "importantSensorsSy",
        "latestSamplesType": "latestFiveMinuteSamples"
    },
    "appkey": "8e2c923e",
    "secret": "abc1154a1f114c33b1001286cb08f93a",
    "opUserUuid": "0be83d40695011e7981e0f190ed6d2e7",
    "netZoneUuid": "b0da759188444aaaa316c8b0aab92662"

}];

export default function configApp(platform) {
    for(let i = 0;i < config.length;i++){
        if(platform == config[i].platform){
            return config[i];
        }
    }
};



// WEBPACK FOOTER //
// ./src/utils/config.js